import { render, staticRenderFns } from "./v-hero-split.vue?vue&type=template&id=362bd336&scoped=true&"
import script from "./v-hero-split.vue?vue&type=script&lang=js&"
export * from "./v-hero-split.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-split.vue?vue&type=style&index=0&id=362bd336&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362bd336",
  null
  
)

export default component.exports